import type { SxProps, Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import * as React from 'react';

export type IconVariant = 'filled' | 'rounded' | 'fw400' | 'wght200' | 'custom' | 'outlined';

export type IconProps = {
	size?: number | string;
	width?: number | string;
	height?: number | string;
	color?: string;
	variant?: IconVariant;
	boxed?: boolean;
	boxRadius?: number;
	boxStroke?: string;
	boxFill?: string;
	fillColor?: string;
	strokeColor?: string;
	strokeWidth?: number;
	className?: string;
	style?: React.CSSProperties;
	sx?: SxProps<Theme>;
	svgProps?: React.ComponentPropsWithoutRef<'svg'>;
	children?: React.ReactNode;
	viewBox?: string;
};

const SvgRoot = styled('svg')<IconProps>({});

export const IconBase = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	const {
		size = 24,
		width,
		height,
		color = 'currentColor',
		boxed = false,
		boxRadius = 4,
		boxStroke = 'currentColor',
		boxFill = 'transparent',
		className,
		style,
		svgProps,
		children,
		sx,
		strokeWidth,
		viewBox = '0 -960 960 960',
	} = props;

	return (
		<SvgRoot
			ref={ref}
			sx={sx}
			{...svgProps}
			width={width ?? size}
			height={height ?? size}
			viewBox={viewBox}
			xmlns="http://www.w3.org/2000/svg"
			role="img"
			className={className}
			style={style}
			strokeWidth={strokeWidth ? Number(strokeWidth) : undefined}
			focusable="false"
			aria-hidden="true"
		>
			{boxed && (
				<rect x="0" y="0" width="24" height="24" rx={boxRadius} fill={boxFill} stroke={boxStroke} />
			)}

			<g fill={color}>{children}</g>
		</SvgRoot>
	);
});
